import { configureStore, combineReducers } from '@reduxjs/toolkit';
import loginSlice from 'slices/loginSlice';

// rootReducer 정의
const rootReducer = combineReducers({
  loginSlice,
});

// RootState 타입 정의
export type RootState = ReturnType<typeof rootReducer>;

// 스토어 설정
const store = configureStore({
  reducer: rootReducer,
});

export default store;
